import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(async () => {
      try {
        await api.post("/auth/refresh");
        const r = await api.get("/auth/me");
        setUser(r.data);
      } catch {
        setUser(false);
      }
    });
  }, []);
  const login = async (email, password) => setUser((await api.post("/auth/login", { email, password })).data);
  const register = async (name, email, password) => (await api.post("/auth/register", { name, email, password })).data;
  const logout = async () => { await api.post("/auth/logout"); setUser(false); };
  return <AuthCtx.Provider value={{ user, login, register, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
